import { useEffect, useState } from "react";
import Select from "../../../../../../components/Select";
import ConfirmDelete from "../../../../../../components/ConfirmDelete";
import helper from "../../../../../../utils/helper";

const ChartsRow = (props) => {
    const { paramsList, onRemove, isNew, canDelete, fullParamsList } = props;

    const [parameter, setParameter] = useState(props.data?.parameter || null);
    const [parametersMerge, setParametersMerge] = useState(props.data?.parametersMerge || []);
    const [parametersMergeList, setParametersMergeList] = useState([]);

    const generateMergeList = (param) => {
        return fullParamsList.filter(item => {
            if (item.value === param.value) return false;

            if (param.type === "linha") return true;

            if (param.type === "barra") return item.type === "linha";

            return false;
        });
    };

    const applyBarRule = () => {
        if (!parameter) return;

        const baseList = generateMergeList(parameter);

        if (parameter.type === "barra") {

            if (parametersMerge.length >= 1) {
                setParametersMergeList(baseList.filter(item => item.value === parametersMerge[0].value));
                return;
            }

            setParametersMergeList(baseList.filter(item => item.type === "linha"));

            return;
        }

        if (parameter.type === "linha") {
            const selectedBar = parametersMerge.find(p => p.type === "barra");
            const selectedLine = parametersMerge.find(p => p.type === "linha");

            if (selectedBar) {
                setParametersMergeList(baseList.filter(item => item.value === selectedBar.value));
                return;
            }

            if (selectedLine) {
                setParametersMergeList(baseList.filter(item => item.type === "linha"));
                return;
            }

            setParametersMergeList(baseList);
        }
    };

    useEffect(() => {
        if (!parameter) {
            setParametersMergeList([]);
            return;
        }

        const baseList = generateMergeList(parameter);
        setParametersMergeList(baseList);

        applyBarRule();
    }, [parameter, parametersMerge, fullParamsList]);

    const handleParameterChange = (param) => {
        const mergeList = generateMergeList(param);

        setParameter(param);
        setParametersMerge([]);
        setParametersMergeList(mergeList);

        if (props.onParameterChange) {
            props.onParameterChange(props.data?.id, param);
        }
    };

    const normalizeMergeParams = (params) => {
        if (!params) return [];

        if (Array.isArray(params)) return params;

        return [params];
    };

    const handleMergeChange = (value) => {
        value = normalizeMergeParams(value);

        setParametersMerge(value);

        if (props.onMergeChange) {
            props.onMergeChange(props.data?.id, value);
        }
    };

    const handleAdd = () => {
        if (!props.onAdd) return;

        if (!parameter) {
            helper.dispatchEvent("showAviso", { message: "Selecione o parâmetro antes de adicionar." });
            return;
        }

        const payload = {
            isNew: true,
            id: parameter.value,
            parameter,
            parametersMerge
        };

        props.onAdd(payload);

        setParameter(null);
        setParametersMerge([]);
        setParametersMergeList([]);
    };

    return (
        <div className="grant-charts__row">
            <div className="grant-charts__select">
                <label>Parâmetro</label>
                <Select
                    value={parameter}
                    options={paramsList}
                    onChange={handleParameterChange}
                    disabled={!isNew}
                />
            </div>

            <div className="grant-charts__select">
                <label>Parâmetros para mescla (opcional)</label>
                <Select
                    value={parametersMerge}
                    options={parametersMergeList}
                    onChange={handleMergeChange}
                    isClearable={parameter?.type === "barra"}
                    isMulti={parameter?.type !== "barra"}
                    ellipsisMulti
                />
            </div>

            {isNew ? (
                <div className="grant-charts__add-btn">
                    <button
                        onClick={handleAdd}
                        className="hdv-btn-forms hdv-btn-green"
                    >
                        Adicionar
                    </button>
                </div>
            ) : canDelete && (
                <div className="grant-charts__remove">
                    <ConfirmDelete
                        enabled
                        type="trash"
                        title="Excluir gráfico"
                        action={onRemove}
                    />
                </div>
            )}
        </div>
    );
};

export default ChartsRow;